import { gql } from '@apollo/client';
import { DeliveryProgressMonitoringOfSlaDetailFilterType } from '../queries/getDeliveryProgressMonitoringOfSlaList';

export const GENERATE_SLA_DETAIL_DOWNLOAD_REPORT = gql`
    mutation GenerateSlaDetailDownloadReport($filter: DeliveryProgressMonitoringOfSlaDetailFilterTypeInput!, $timezone: String) {
        generateSlaDetailDownloadReport(filter: $filter, timezone: $timezone)
    }
`;

export interface GenerateSlaDetailDownloadReportVariables {
    filter: DeliveryProgressMonitoringOfSlaDetailFilterType;
    timezone?: string;
}

export interface GenerateSlaDetailDownloadReportResponse {
    generateSlaDetailDownloadReport: string;
}

